import React, { Fragment } from "react";
import "containers/ProjectCommon.css";
import "containers/Projects/StartProject/Step_3/StartProjectStepThree.css";
import AxiosConfig from "axiosConfig";
import ProjectBanner from "components/Project/ProjectBanner";
import ProjectOldInfo from "components/Project/Details/ProjectOldInfo";
import ProgressStepper from "components/Project/ProgressStepper";
import InviteFriends from "components/Project/StartProject/Step_3/ImageFriends";
import FriendsSearchGrid from "components/Project/StartProject/Step_3/FriendsSearchGrid";
import FriendsInvitedGrid from "components/Project/StartProject/Step_3/FriendsInvitedGrid";
import UnregisteredFriendsInvite from "components/Project/StartProject/Step_3/UnregisteredFriendsInvite";
import TextArea from "components/General/Form/TextArea";
import TwoButtonLayout from "components/General/Form/CustomButton/TwoButtonLayout";
import TextTheme from "components/General/Text/TextTheme";
import * as FriendsSearchHelper from "components/Project/FriendsSearcHelper/FriendsSearchHelper";
import GroupProjectInvite from "components/Project/StartProject/Step_3/GroupProjectInvite";

class StartProjectStepThree extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectSlug: this.props.match.params.slug,
      projectBanner: "",
      projectName: "",
      projectDateStarted: "Date Started",
      popupSearch: false,
      searchType: "",
      searchValue: "",
      searchMoreAvailable: true,
      searchLessAvailable: true,
      searchPage: 1,
      selectedFriends: new Map(),
      inviteMessage: "Hello Friends",
      unregisteredUser: [
        { email_address: "", issue: "", status: null },
        { email_address: "", issue: "", status: null },
        { email_address: "", issue: "", status: null },
        { email_address: "", issue: "", status: null },
        { email_address: "", issue: "", status: null },
      ],
      unregisteredUserIssue: "",
      sendInvitationIssue: "",
      friendsSearchData: [],
      my_groups: "",
      group_names: "",
      selected_group: "",
      adventureId: this.props.location.state.adventureId,
      adventureSlug: this.props.location.state.adventureSlug,
    };
  }

  componentDidMount() {
    const projectSlug = this.props.location.state.projectSlug;
    AxiosConfig.get(`impactprojects/project/${projectSlug}/`)
      .then((res) => {
        this.setState({
          projectSlug: projectSlug,
          projectName: res.data["name"],
          projectBanner: res.data["banner"],
        });
      })
      .catch();

    // call fetchOwnerGroups
    this.fetchOwnerGroups(this);
    window.onpopstate = (e) => {
      this.onBackButtonEvent();
    };
  }
  onBackButtonEvent = () => {
    this.props.history.push({
      pathname: `/projects/`
    });
  };
  /**
   * Make Axios call to endpoint groups/list/owner
   */
  fetchOwnerGroups(obj) {
    AxiosConfig.get("groups/list/owner/")
      .then((response) => {
        // make the list group names
        let names = [];
        response.data.forEach((elem) => {
          names.push(elem.group.name);
        });
        obj.setState({
          my_groups: response.data,
          group_names: names,
        });
      })
      .then(() => {
        obj.fetchModeratorGroups(obj);
      });
  }

  /**
   * Make Axios call to endpoint groups/list/moderator
   */
  fetchModeratorGroups(obj) {
    AxiosConfig.get("groups/list/moderator/").then((response) => {
      // add to the names list
      let names = this.state.group_names;
      let groupData = this.state.my_groups;
      response.data.forEach((elem) => {
        names.push(elem.group.name);
        groupData.push(elem);
      });

      obj.setState({
        my_groups: groupData,
        group_names: names,
      });
    });
  }

  /*
    This method will actually call the backend API and fetch the friends result based on the search query
     */
  fetchFriendsData(obj, searchType, searchValue, page, searchMoreFlag) {
    FriendsSearchHelper.fetchFriendsDataHelper(
      obj,
      searchType,
      searchValue,
      page,
      searchMoreFlag
    );
  }

  sendInviteButtonClick(event) {
    if (event == "skip") {
      this.setState({ sendInvitationIssue: "" });
      this.sendInvitationToUsers(this, event);
    }
    else {
      if (
        this.checkUnregisteredUsersErr() === false
        //  &&
        // this.checkInvitationMessageErr() === false
      ) {
        this.setState({ sendInvitationIssue: "" });
        this.sendInvitationToUsers(this, event);
      }
    }
  }

  checkInvitationMessageErr() {
    if (this.state.inviteMessage.length === 0) {
      this.setState({
        sendInvitationIssue:
          "Enter an Invitation message to be sent to your invitee's.",
      });
      return true;
    }
    return false;
  }
  checkUnregisteredUsersErr() {
    let errorFlag = false;
    let duplicateEmail = false;
    for (let i = 0; i < this.state.unregisteredUser.length; i++) {
      // nested for loop
      for (let j = 0; j < this.state.unregisteredUser.length; j++) {
        // prevents the element from comparing with itself
        if (i !== j && this.state.unregisteredUser[i].email_address !== "") {
          // check if elements' values are equal
          if (
            this.state.unregisteredUser[i].email_address ===
            this.state.unregisteredUser[j].email_address
          ) {
            // duplicate element present
            duplicateEmail = true;
            // terminate inner loop
            break;
          }
        }
      }
    }
    if (duplicateEmail) {
      errorFlag = true;
      this.setState({
        sendInvitationIssue: "Duplicate emails found",
      });
    }
    for (let i = 0; i < this.state.unregisteredUser.length; i++) {
      if (this.state.unregisteredUser[i]["issue"].trim().length !== 0) {
        errorFlag = true;
        this.setState({
          sendInvitationIssue: "Please provide valid email address",
        });
        break;
      }
    }

    return errorFlag;
  }

  sendInvitationToUsers(obj, event) {
    let form_data = new FormData();
    const {
      projectUserId,
      projectSlug,
      goalDate,
      challengeSlug,
      adventureId,
      adventureSlug,
    } = this.props.location.state;
    for (const friends of this.state.selectedFriends.values()) {
      form_data.append("registered_user", friends["user_email"]);
    }
    for (let i = 0; i < this.state.unregisteredUser.length; i++) {
      form_data.append(
        "unregistered_user",
        this.state.unregisteredUser[i]["email_address"].trim()
      );
    }
    form_data.append("challenge", challengeSlug);
    form_data.append("project", projectSlug);
    form_data.append("invitation_message", this.state.inviteMessage);
    form_data.append("goal_date", goalDate);
    form_data.append("projectUserId", projectUserId);

    let nextUrl = "";
    if (this.state.adventureSlug == "SPREAD_THE_WORD") {
      nextUrl = "/projects/" + this.state.projectSlug + "/spread-the-word";
    } else if (this.state.adventureSlug == "LEARN_NEW_SKILL") {
      nextUrl = "/projects/" + this.state.projectSlug + "/learn-new-skill";
    } else if (this.state.adventureSlug == "DEVELOP_NEW_HABIT") {
      nextUrl = "/projects/" + this.state.projectSlug + "/develop-new-habit";
    } else if (this.state.adventureSlug == "VOLUNTEER") {
      nextUrl = "/projects/" + this.state.projectSlug + "/volunteer-time";
    } else if (this.state.adventureSlug == "GIVE_A_DONATION") {
      nextUrl = "/projects/" + this.state.projectSlug + "/give-a-donation";
    } else if (this.state.adventureSlug == "RAISE_FUNDS") {
      nextUrl = "/projects/" + this.state.projectSlug + "/fundraise";
    } else if (this.state.adventureSlug == "RAISE_YOUR_VOICE") {
      nextUrl = "/projects/" + this.state.projectSlug + "/raise-your-voice";
    }
    if (event === "skip") {
      obj.props.history.push({
        pathname: nextUrl,
        state: {
          challengeSlug: challengeSlug,
          projectSlug: projectSlug,
          projectBanner: this.state.projectBanner,
          adventureId: adventureId,
          adventureSlug: adventureSlug,
          goalDate: goalDate,
          projectUserId: projectUserId,
          showStepper: true,
        },
      });
    } else {
      AxiosConfig.post(`/impactprojects/invite_user_new/`, form_data)
        .then((response) => {
          //if there is no group to post invitations to, then change page.
          if (!this.state.selected_group)
            obj.props.history.push({
              pathname: nextUrl,
              state: {
                challengeSlug: challengeSlug,
                projectSlug: projectSlug,
                projectBanner: this.state.projectBanner,
                adventureId: adventureId,
                adventureSlug: adventureSlug,
                goalDate: goalDate,
                projectUserId: projectUserId,
                showStepper: false,
              },
            });
          //else send invitations to the group as well
          else obj.sendInvitationToGroup(obj, nextUrl);
        })
        .catch(function (error) { });
    }
  }

  /**
   * Function invite all the members of a group
   */
  sendInvitationToGroup(obj, nextUrl) {
    let form_data = new FormData();
    const {
      goalDate,
      challengeSlug,
      projectSlug,
      adventureId,
      adventureSlug,
      projectUserId,
    } = this.props.location.state;
    // construct the form data
    form_data.append("group", this.state.selected_group.id);
    form_data.append("project", this.state.projectSlug);
    form_data.append("invitation_message", this.state.inviteMessage);
    form_data.append("challenge", challengeSlug);
    form_data.append("projectUserId", projectUserId);

    //post to the invite group endpoint
    AxiosConfig.post(`impactprojects/invite_group/`, form_data)
      .then((response) => {
        obj.props.history.push({
          pathname: nextUrl,
          state: {
            challengeSlug: challengeSlug,
            projectSlug: projectSlug,
            projectBanner: this.state.projectBanner,
            adventureId: adventureId,
            adventureSlug: adventureSlug,
            goalDate: goalDate,
            projectUserId: projectUserId,
          },
        });
      })
      .catch(function (error) { });
  }

  render() {
    return (
      <Fragment>
        <div className="header_main">
          {this.state.popupSearch ? (
            <FriendsSearchGrid
              searchData={this.state.friendsSearchData}
              searchStringType={this.state.searchType}
              searchStringValue={this.state.searchValue}
              searchMore={this.state.searchMoreAvailable}
              searchLess={this.state.searchLessAvailable}
              searchResultCancelClick={FriendsSearchHelper.searchResultCancelClick.bind(
                this
              )}
              searchResultDoneClick={FriendsSearchHelper.searchResultDoneClick.bind(
                this
              )}
              searchResultNextClick={FriendsSearchHelper.searchResultNextClick.bind(
                this
              )}
              searchResultBackClick={FriendsSearchHelper.searchResultBackClick.bind(
                this
              )}
              searchResultImageClick={FriendsSearchHelper.searchResultImageClick.bind(
                this
              )}
            />
          ) : null}

          <div className="page_main">
            <div className="page_info_vr_content_main">
              <ProjectOldInfo
                vertical={true}
                project={this.props.location.state.projectSlug}
              />
            </div>
            <div className="page_details_main">
              <div className="project-banner">
                <ProjectBanner image={this.state.projectBanner} />
              </div>
              <div className="page_info_hr_content_main">
                <ProjectOldInfo
                  project={this.props.location.state.projectSlug}
                  showChallengeDetails={true}
                />
              </div>
              <div className="page_details_content_main mt-15 border-0">
                <div className="stepper_main_content">
                  <ProgressStepper
                    currentStep="3"
                    challengeSlug={this.props.location.state.challengeSlug}
                    goalDate={this.props.location.state.goalDate}
                    adventureId={this.props.location.state.adventureId}
                    projectSlug={this.props.location.state.projectSlug}
                    adventureSlug={this.props.location.state.adventureSlug}
                    projectUserId={this.props.location.state.projectUserId}
                    showStepper={true}
                  />
                </div>
              </div>
              <div className="page_details_content_main">
                <InviteFriends
                  showHeaderMessage={true}
                  message="1. Build your team by inviting family and friends to your project."
                  searchResultHandler={FriendsSearchHelper.searchResultHandler.bind(
                    this
                  )}
                  disabled={this.state.popupSearch}
                />

                <div>
                  <br></br>
                  <FriendsInvitedGrid
                    friendsInvitedData={[
                      ...this.state.selectedFriends.values(),
                    ]}
                    removeInviteClick={FriendsSearchHelper.removeInviteClick.bind(
                      this
                    )}
                  />
                </div>

                <GroupProjectInvite
                  groups={this.state.my_groups}
                  groupNames={this.state.group_names}
                  caller={this}
                />
                <UnregisteredFriendsInvite
                  message={
                    (this.state.my_groups ? "3" : "2") +
                    ". Send invites to unregistered users."
                  }
                  unregisteredUser={this.state.unregisteredUser}
                  unregisteredUserIssue={this.state.unregisteredUserIssue}
                  unregisteredUserAddMoreClick={FriendsSearchHelper.unregisteredUserAddMore.bind(
                    this
                  )}
                  unregisteredUserEmailChange={FriendsSearchHelper.unregisteredUserEmailChange.bind(
                    this
                  )}
                  unregisteredUserDeleteClick={FriendsSearchHelper.unregisteredUserDeleteClick.bind(
                    this
                  )}
                  unregisteredUserEmailValidate={FriendsSearchHelper.unregisteredUserEmailValidate.bind(
                    this
                  )}
                  disabled={this.state.popupSearch}
                />

                <br />
                <hr />
                <div className="mt-15">
                  <TextTheme
                    message={
                      (this.state.my_groups ? "4" : "3") +
                      ". Invitation message to friends."
                    }
                    className="text_small text_black"
                  />
                  <TextArea
                    value={this.state.inviteMessage}
                    rows={5}
                    handleChange={FriendsSearchHelper.inviteMessageChange.bind(
                      this
                    )}
                  />
                </div>
                <TextTheme
                  message={this.state.sendInvitationIssue}
                  className="text_small text_red mt-15 mb-15"
                />
                <TwoButtonLayout
                  button1Text="SKIP"
                  button2Text="SEND INVITATIONS"
                  button1Click={this.sendInviteButtonClick.bind(this, "skip")}
                  button2Click={this.sendInviteButtonClick.bind(this, "send")}
                  disabled={this.state.popupSearch}
                />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default StartProjectStepThree;
